module.exports = __webpack_public_path__ + "media/images/menu/amalthea-276e45c24a7668a2e1892611b112de2d.jpg";